import React, { Fragment } from 'react';
import { ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { useEditorContext } from '@philips-internal/oswald-ui-core/lib/component/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
const WizardStepGroupContainer = {
    acceptedTypes: [
        ComponentType.FORM,
    ],
    name: '',
};
function InternalWizardStepGroup(props) {
    const editorContext = useEditorContext();
    const isDesigning = Boolean(editorContext?.isDesigning());
    if (!props.identifier && !isDesigning) {
        return null;
    }
    if (!isDesigning) {
        return (React.createElement(Fragment, null, props.children));
    }
    return (React.createElement(Container, { acceptedTypes: WizardStepGroupContainer.acceptedTypes, className: "c-wizard-group", uuid: props.uuid },
        React.createElement("div", { className: "c-wizard-group__title" }, MessageService.translate(props.title)),
        props.children));
}
export { InternalWizardStepGroup, WizardStepGroupContainer, };
//# sourceMappingURL=internal-wizard-step-group.js.map